import { z } from 'zod';

import { WizardStep } from '../../../resources/constants';
import { schema as accountUsageOneSchema } from '../../accountUsageOne/resources/schema';
import { schema as accountUsageThreeSchema } from '../../accountUsageThree/resources/schema';
import { schema as accountUsageTwoSchema } from '../../accountUsageTwo/resources/schema';
import { schema as additionalDocumentsSchema } from '../../additionalDocuments/resources/schema';
import { schema as companyAddressesSchema } from '../../companyAddresses/resources/schema';
import { schema as companyInfoSchema } from '../../companyInfo/resources/schema';
import { schema as companySectorSchema } from '../../companySector/resources/schema';
import { schema as personsBasicSchema } from '../../personsBasic/resources/schema';
import { schema as personsDetailsSchema } from '../../personsDetails/resources/schema';
import { schema as personsSettingsSchema } from '../../personsSettings/resources/schema';

export const stepToSchemaMap = {
    [WizardStep.UserInfo]: z.object({}),
    [WizardStep.CompanyInfo]: companyInfoSchema,
    [WizardStep.CompanyAddresses]: companyAddressesSchema,
    [WizardStep.CompanySector]: companySectorSchema,
    [WizardStep.AccountUsageStep1]: accountUsageOneSchema,
    [WizardStep.AccountUsageStep2]: accountUsageTwoSchema,
    [WizardStep.AccountUsageStep3]: accountUsageThreeSchema,
    [WizardStep.PersonsBasic]: personsBasicSchema,
    [WizardStep.PersonsSettings]: personsSettingsSchema,
    [WizardStep.PersonsDetails]: personsDetailsSchema,
    [WizardStep.AdditionalDocuments]: additionalDocumentsSchema,
    [WizardStep.Submit]: z.object({}),
};

export {
    accountUsageOneSchema,
    accountUsageThreeSchema,
    accountUsageTwoSchema,
    additionalDocumentsSchema,
    companyAddressesSchema,
    companyInfoSchema,
    companySectorSchema,
    personsBasicSchema,
    personsSettingsSchema,
};
